import { useInterceptors } from '@app/config/api'
import { LoaderFullScreen } from '@components/loader-full-screen'
import { useMaterialIconsFont } from '@components/map'
import { useCheckAndUpdateSession } from '@entities/session'
import { useObserveMapLayers } from '@features/cluster'
import { useObserveUsersList } from '@features/users'
import { ToastContainer } from '@shared/lib/redux-toast'
import { Redicrector } from '@shared/lib/router'
import '@styles/toast.css'
import { Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { Suspense, useEffect, useState } from 'react'

export const LayoutPage = () => {
  useInterceptors()
  useObserveMapLayers()
  useObserveUsersList()
  useMaterialIconsFont()

  const { updateSession: loadSession, status: profileStatus } =
    useCheckAndUpdateSession()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    loadSession()
  }, [loadSession])

  useEffect(() => {
    if (profileStatus === 'success' || profileStatus === 'error') {
      setIsLoading(false)
    }
  }, [profileStatus])

  if (isLoading) {
    return <LoaderFullScreen />
  }

  return (
    <>
      {import.meta.env.DEV && <TanStackRouterDevtools />}
      <Redicrector />
      <Suspense>
        <ToastContainer />
      </Suspense>
      <Outlet />
    </>
  )
}
